import { render, staticRenderFns } from "./order_payinfojigou.vue?vue&type=template&id=465bfd8e&scoped=true&"
import script from "./order_payinfojigou.vue?vue&type=script&lang=js&"
export * from "./order_payinfojigou.vue?vue&type=script&lang=js&"
import style0 from "./order_payinfojigou.vue?vue&type=style&index=0&id=465bfd8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465bfd8e",
  null
  
)

export default component.exports